export const onUpdateWorkspaceEventNoFilter = /* GraphQL */ `
  subscription OnUpdateWorkspaceEvent($owner: String) {
    onUpdateWorkspaceEvent(owner: $owner) {
      id
      owner
      title
      visibility
      userID
      type
      targetIP
      targetParserURL
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
      entities {
        items {
          id
          owner
          label
          type
          emoji
          parentEntity
          backgroundColor
          workspaceID
          _version
          _deleted
          _lastChangedAt
          createdAt
          updatedAt
        }
        nextToken
        startedAt
      }
      trainingLogs {
        items {
          id
          owner
          createdBy
          status
          duration
          workspaceID
          _version
          _deleted
          _lastChangedAt
          createdAt
          updatedAt
        }
        nextToken
        startedAt
      }
    }
  }
`;
export const onDeleteWorkspaceEventNoFilter = /* GraphQL */ `
  subscription OnDeleteWorkspaceEvent($owner: String) {
    onDeleteWorkspaceEvent(owner: $owner) {
      id
      owner
      title
      visibility
      userID
      type
      targetIP
      targetParserURL
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
      entities {
        items {
          id
          owner
          label
          type
          emoji
          parentEntity
          backgroundColor
          workspaceID
          _version
          _deleted
          _lastChangedAt
          createdAt
          updatedAt
        }
        nextToken
        startedAt
      }
      trainingLogs {
        items {
          id
          owner
          createdBy
          status
          duration
          workspaceID
          _version
          _deleted
          _lastChangedAt
          createdAt
          updatedAt
        }
        nextToken
        startedAt
      }
    }
  }
`;

export const onUpdateEntityAiEventNoFilter = /* GraphQL */ `
  subscription onUpdateEntityAIEvent($owner: String, $workspaceID: ID) {
    onUpdateEntityAIEvent(owner: $owner, workspaceID: $workspaceID) {
      id
      owner
      label
      type
      emoji
      parentEntity
      backgroundColor
      workspaceID
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteEntityAiEventNoFilter = /* GraphQL */ `
  subscription OnDeleteEntityAiEvent($owner: String, $workspaceID: ID) {
    onDeleteEntityAIEvent(owner: $owner, workspaceID: $workspaceID) {
      id
      owner
      label
      type
      emoji
      parentEntity
      backgroundColor
      workspaceID
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;

export const getUserByEmail = /* GraphQL */ `
  query getUserByEmail {
    listUsers {
      items {
        id
        owner
        username
        user_email
        user_email_verified
        type
      }
    }
  }
`;

export const onUpdateChatPlanner = /* GraphQL */ `
  subscription OnUpdateChat($filter: ModelSubscriptionChatFilterInput) {
    onUpdateChat(filter: $filter) {
      id
      owner
      name
      description
      status {
        status
        lastUpdated
      }
      workspaceID
      creationTime
      createdBy
      updatedBy
      visibility
      isAIReplying
      activeMessageForAI
      chatHistory
      topics
      documentId
      primaryRole
      primaryAgent
      plannerAgent
      forcePlannerStop
      allowMultipleRoles
      handedOffToHuman
      roles
      language
      summary
      caseId
      customerId
      caseInfo
      customerInfo
      metadata
      channelSettings
      externalParticipantId
      canvasID
      canvasOperations
      canvasLastChangesetID
      planFile
      planStatus
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;

export const onUpdateAppLogSocket = /* GraphQL */ `
  subscription OnUpdateAppLog($workspaceID: ID, $status: String) {
    onUpdateAppLogEvent(workspaceID: $workspaceID, status: $status) {
      __typename
      id
      type
      filename
      event
      status
      workspaceID
    }
  }
`;
export const onUpdateWorkspaceSocket = /* GraphQL */ `
  subscription OnUpdateWorkspace($owner: String, $id: ID) {
    onUpdateWorkspaceEvent(owner: $owner, id: $id) {
      id
      owner
      title
      visibility
      userID
      isMed
      type
      usagePlanID
      workspaceTokenID
      workspaceToken
      subscriptionType
      subscriptionId
      subscriptionStatus
      enableExperimentalFeatures
      utilityEndpoint
      utilityUrl
      utilityUrlStatus
      utilityUrlType
      utilityBaseModel
      utilityProvider
      codingEndpoint
      codingUrl
      codingUrlStatus
      codingUrlType
      codingBaseModel
      codingProvider
      generalPurposeEndpoint
      generalPurposeUrl
      generalPurposeUrlStatus
      generalPurposeUrlType
      generalPurposeBaseModel
      generalPurposeProvider
      qaEnpoint
      qaUrl
      qaUrlStatus
      qaUrlType
      qaBaseModel
      qaProvider
      cnEndpoint
      cnUrl
      cnUrlStatus
      cnUrlType
      cnBaseModel
      cnProvider
      gnEnpoint
      gnUrl
      gnUrlStatus
      gnUrlType
      gnBaseModel
      gnProvider
      nlpEnpoint
      nlpUrl
      nlpUrlStatus
      nlpUrlType
      nlpBaseModel
      nlpProvider
      embeddingEndpoint
      embeddingUrl
      embeddingUrlStatus
      embeddingUrlType
      embeddingBaseModel
      embeddingProvider
      chartingEndpoint
      chartingUrl
      chartingUrlStatus
      chartingUrlType
      chartingBaseModel
      chartingProvider
      imagingEndpoint
      imagingUrl
      imagingUrlStatus
      imagingUrlType
      imagingBaseModel
      imagingProvider
      reasoningEndpoint
      reasoningUrl
      reasoningUrlStatus
      reasoningUrlType
      reasoningBaseModel
      reasoningProvider
      billingStatus
      lastBillingDate
      lastConsumptionNotificationDate
      activeUntil
      billingPeriodStart
      billingPeriodEnd
      paymentFailed
      bulkImportAllowed
      lastPaymentAttempt
      targetSubscriptionType
      lastChangeSubscriptionDate
      maxUsers
      baseModel
      domain
      customImageRecognitionModel
      customVectorDB
      disabled
      users
      workspaceCreationDate
      workspaceModelReady
      enableDeleteFunctionInAgents
      enableUpdateFunctionInAgents
      enableCustomFunctionInAgents
      defaultChatAgent
      defaultBusinessAnalystAgent
      defaultContentCreatorAgent
      isSentimentReviewerEnabled
      isExtendedContentCreatorEnabled
      isExtendedBusinessAnalystReportEnabled
      customIndexedDBendpoint
      createdBy
      updatedBy
      federationMetadataUrl
      federationMetadataUrlStatus
      federationMetadataUrlType
      ssoType
      ssoDomain
      ssoProviderName
      isMultiLanguageEnabled
      customChartingConfig
      twilioConfig
      emailConfig
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
